import styled from 'styled-components'

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const UsersSection = styled.div`
  &:first-child:not(:only-child) {
    padding-bottom: 24px;
  }

  &:last-child:not(:only-child) {
    padding-top: 24px;
    border-top: 1px solid var(--t-separator-border-primary);
  }
`

export const UsersSectionTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`
